import { ref } from 'vue'

export function useCep() {
  const cepLoading = ref(false)
  const cepError = ref('')

  const maskCep = (value) => {
    const digits = String(value || '').replace(/\D/g, '').slice(0, 8)
    if (digits.length > 5) return digits.slice(0, 5) + '-' + digits.slice(5)
    return digits
  }

  const lookupCep = async (rawCep, fillFn) => {
    const cep = String(rawCep || '').replace(/\D/g, '')
    if (cep.length !== 8) return

    cepLoading.value = true
    cepError.value = ''

    try {
      const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
      if (!res.ok) throw new Error('Falha na requisição')
      const data = await res.json()

      if (data.erro) {
        cepError.value = 'CEP não encontrado'
        return
      }

      fillFn({
        address: data.logradouro || '',
        neighborhood: data.bairro || '',
        city: data.localidade || '',
        state: data.uf || '',
        zip_code: data.cep || rawCep,
      })
    } catch {
      cepError.value = 'Erro ao consultar CEP'
    } finally {
      cepLoading.value = false
    }
  }

  return { cepLoading, cepError, maskCep, lookupCep }
}
